import { render, staticRenderFns } from "./ExibicaoImovel.vue?vue&type=template&id=1aa373a0&"
import script from "./ExibicaoImovel.vue?vue&type=script&lang=js&"
export * from "./ExibicaoImovel.vue?vue&type=script&lang=js&"
import style0 from "./ExibicaoImovel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports